import { fromJS } from 'immutable'
import {
  LEAVE_TYPE_GET_REQUEST,
  LEAVE_TYPE_GET_SUCCESS,
  LEAVE_TYPE_GET_FAILURE,
  LEAVE_TYPE_GET_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case LEAVE_TYPE_GET_REQUEST:
      return state
        .set('isFetching', true)
    case LEAVE_TYPE_GET_SUCCESS:
      return state
        .set('leaveType', fromJS(action.payload.leaveType[0]))
        .set('isFetching', false)
    case LEAVE_TYPE_GET_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case LEAVE_TYPE_GET_RESET:
      return state
        .delete('leaveType')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/leave-type/leave-type-get-reducer.js